import {Component, NgZone, OnInit} from '@angular/core';
import {FontList} from '../FontList';
import {Detector} from '../Detector';
import {AppService} from '../app.service';
declare let $: any;
declare let Konva: any;
declare let window: any;

@Component({
  selector: 'card-controller-mobile',
  templateUrl: './cardControllerMobile.component.html',
  styleUrls: ['./cardControllerMobile.component.css', '../app.component.css']
})
export class CardControllerMobileComponent implements OnInit {
  cardBackList = [];
  passedInit = false;
  savedCardWidth = 0;
  showCreatedCards = false;

  constructor(public app: AppService, private zone: NgZone) {

  }

  ngOnInit() {
    if (!this.passedInit) {
      setTimeout(() => {
        this.passedInit = true;
        console.log("Setting passed init");
      }, 2000);
    }
  }

  savedCardStyle(cardBack) {
    let usedWidth = 0;
    if (!this.passedInit) {
      let el = document.getElementById("savedCard" + cardBack.id);
      if (!el) {
        return {};
      }
      usedWidth = el.clientWidth;
      this.savedCardWidth = usedWidth;
    } else {
      usedWidth = this.savedCardWidth;
    }
    return (this.app.selectedSavedCard && cardBack.id === this.app.selectedSavedCard.id) ?
      {'border': '1px solid green', 'height': (Math.ceil((usedWidth - 10) * 1.4463)) + 'px'} :
      {'border': '1px solid black', 'height': (Math.ceil((usedWidth - 10) * 1.4463)) + 'px'};
  }

  savedCardClicked(card) {
    this.app.selectedSavedCard = card;
    this.app.cardAdChanged = false;
    console.log("Card clicked: ", card);
    this.app.broadcast({event: 'selCardChanged'})
  }

  getPreviewBoxHeight() {
    let width = window.innerWidth < 1400 ? "100%" : "100%";
    let height = 860;
    return {'height': '100%', 'min-height': height + 'px', 'width': width};
  }

  getPreviewCanvasSize() {
    let container = document.getElementById("previewCanvasBox");
    let totalWidth = container.clientWidth - 40;
    let left = (totalWidth - 40) / 2;
    return {'height': (totalWidth * 1.6) + 'px', width: totalWidth + 'px', left: '20px'};
  }

  backToCardCreation() {
    this.app.showReady = false;
    this.app.broadcast({event: 'backToCardCreation'});
  }

  makeCardCustom() {
    this.app.broadcast({event: 'customSwitch'});
    // setTimeout(() => {
    //   window.scrollTo(0, document.getElementById('customCardViewsSection').offsetTop);
    // }, 300);
  }

  makeCardSponsor() {
    this.app.broadcast({event: 'advertisementSwitch'});
    // this.app.makeCardSponsor(this.app.selectedSavedCard.id, true, false, false).subscribe((data) => {
    //   this.app.selectedSavedCard.advertisement = true;
    //   console.log("Card made sponsor: ", data);
    //
    //   // setTimeout(() => {
    //   //   console.log("Scroll top: ", document.getElementById("locationSection").offsetTop);
    //   //   window.scrollTo(0, document.getElementById("locationSection").offsetTop);
    //   // }, 300);
    // }, (error) => {
    //   console.log("Making card sponsor error: ", error);
    // });
  }

  expandSavedTabClicked() {
    this.showCreatedCards = !this.showCreatedCards;
  }

  editCard() {
    this.app.broadcast({event: 'editCard', data: this.app.selectedSavedCard});
  }

  getEditCardStyle() {
    if (!this.app.hasImageForID[this.app.selectedSavedCard.id]) {
      return {'opacity': 0.5, 'pointer-events': 'none', 'cursor': 'not-allowed'};
    }
    return {};
  }

  deleteCard() {
    let session = this.app.getSessionID();
    console.log("SessionID: ", session);
    // if (this.app.selectedSavedCard.impressions_left > 0) {
    //   alert("You are unable to delete this card, there are still impressions remaining.");
    //   return;
    // }
    // if (this.app.selectedSavedCard.custom_uses > 0) {
    //   alert("You are unable to delete this card, there are still custom uses remaining.");
    //   return;
    // }
    this.app.deleteCard(this.app.selectedSavedCard.id).subscribe((data) => {
      console.log("Card deleted: ", data);
      this.app.userCards = this.app.userCards.filter((card) => {
        return card.id !== this.app.selectedSavedCard.id;
      });
      this.app.selectedSavedCard = null;
    }, (error) => {
      console.log("Card delete error: ", error);
    });
  }

  checkRejection() {
    alert(this.app.selectedSavedCard.reason_for_denial);
  }

  customTimeRemains() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    let now = new Date();
    return d > now;
    // return true;
  }

  getDateOutput() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    return "" + (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear();
  }

  expirationTime() {
    let days = this.getDayDifferenceForDates();
    let hours = this.getHourDifferenceBetween();
    let min = this.getMinuteDifferenceBetween();
    if (days > 1) {
      return days + " Days, " + hours + " Hour(s) and " + min + " Minute(s)";
    } else if (days === 1) {
      return days + " Day, " + hours + " Hour(s) and " + min + " Minute(s)";
    } else if (hours > 1) {
      return hours + " Hours and " + min + " Minute(s)";
    } else if (hours === 1) {
      return hours + " Hour and " + min + " Minute(s)";
    } else {
      return min + ((min > 1) ? " Minutes" : "Minute");
    }
  }

  checkDateLessThanFiveDays() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    d.setDate(d.getDate() - 5);
    let now = new Date();
    return now > d;
  }

  getDayDifferenceForDates() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    let now = new Date();
    let timeDiff = Math.abs(d.getTime() - now.getTime());
    let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  }

  getHourDifferenceBetween() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    let now = new Date();
    let timeDiff = Math.abs(d.getTime() - now.getTime());
    let diffHours = Math.floor(timeDiff / (1000 * 3600)) % 24;
    return diffHours;
  }

  getMinuteDifferenceBetween() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    let now = new Date();
    let timeDiff = Math.abs(d.getTime() - now.getTime());
    let diffMin = Math.floor(timeDiff / (1000 * 60)) % 60;
    return diffMin;
  }

}
